import wizard_headingHtml from './wizard-heading.html?raw';

export const template = wizard_headingHtml;

export interface IWizardHeadingParams {
    headingKey: KnockoutObservable<string>;
    descriptionKey: KnockoutObservable<string>;
}

export class viewModel {
    constructor(public params: IWizardHeadingParams) {}
}
